// extracted by mini-css-extract-plugin
module.exports = {"home":"App_home__1CYBE","content":"App_content__3CTFh","hcentered":"App_hcentered__1EkTk"};